/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { ILianxinMenuViewProps } from './lianxin-menu';

export class LianxinMenuView extends React.PureComponent<ILianxinMenuViewProps> {
    public state: any = this.props.config.menuItems![0];

    public render(): JSX.Element | null {
        return (
            <div>
                <div className='row'>
                    {this.props.config.menuItems?.map((d, idx) => (
                        <div key={idx} className='col-sm' style={{ padding: '0.5rem' }}>
                            <button
                                type='button'
                                className={`btn btn-lg shadow-none lianxinmenu ${
                                    d.menuItemName === this.state.menuItemName ? 'active' : ''
                                }`}
                                onClick={() => this.setState(d)}
                            >
                                {d.menuItemName}
                            </button>
                        </div>
                    ))}
                </div>
                <div className='row' style={{ paddingTop: '2rem' }}>
                    <img src={this.state.menuItemImage.src} alt='menu' />
                </div>
            </div>
        );
    }
}
export default LianxinMenuView;
